import { createBoldToastMessage as util } from "@coreapp/utils/createBoldToastMessage";

export const createBoldToastMessage = (
  templateStr: string,
  replacements?: Record<string, string>
) => {
  return util(templateStr, replacements);
};
